<template>
	<v-footer bottom>
	 <div class="cm-row">
      <div class="global-footer">
		<nav class="main-nav" style="padding-left: 35vh; padding-right: 35vh;text-align: left;">
          <div class="col-lg-3" style="padding-bottom: 4%;">
            <img class="emersonLogofooter" style="width: 154px; height: auto;" src="https://www.emerson.com/resource/blob/emerson-logo-data-9860160.png">
            <p style="font-family: 'Noto Sans', sans-serif; font-weight: bold; padding-top: 15%; color: white;">Go Boldly.™</p>
            <p style="padding-top: 2%; line-height: 1.71; color: white; font-size: .875rem;">Emerson is the global technology, software and engineering powerhouse driving innovation that makes the world healthier, safer, smarter and more sustainable.</p>
            <a href="http://www.emerson.com/en-us/about-us/emerson-and-stem">
              <div class="image-container" >
                <img style="width: 100%; height:auto;" src="http://www.emerson.com/resource/blob/em17r18-stem-fall-footer-746x196-data-1529172.jpg" alt="EMR_ILoveStemFooterPromo_746x196_092216" title="EMR_ILoveStemFooterPromo_746x196_092216"/>
              </div> 
            </a>
          </div>
          <div class="col-lg-2">
            <div style="border-left: 1px solid white; height: 339px; margin-left: 21%;"></div>
          </div>
          <div class="col-lg-7" style="margin-left: -9.5%">
            <div class="col-lg-5" style="padding-top: 0.8%;">
              <p class="ourFont">Our Company</p>
                <a href="https://www.emerson.com/en-us/about-us/leadership" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Leadership</a><br /><br />
                <a href="https://www.emerson.com/en-us/esg" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Environmental, Social & Governance</a><br /><br />
                <a href="https://www.emerson.com/en-us/careers" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Careers</a><br /><br />
                <a href="https://www.emerson.com/en-us/careers/diversity-and-inclusion" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Diversity, Equity & Inclusion</a><br /><br />
                <a href="https://www.emerson.com/en-us/contact-us" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Contact Us</a><br /><br />
                <a href="https://www.emerson.com/en-us/news" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Newsroom</a><br /><br />
                <a href="https://www.emerson.com/en-us/investors" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Investors</a><br /><br />
            </div>
            <div class="col-lg-4" style="padding-top: 0.8%;">
              <p class="ourFont">Our Passions</p>
              <a href="https://www.emerson.com/en-us/esg/environmental-sustainability" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Sustainability</a><br /><br />
                <a href="https://www.emerson.com/en-us/perspectives" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Perspectives</a><br /><br />
                <a href="https://www.emerson.com/en-us/innovations" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Innovations</a><br /><br />
                <a href="https://www.emerson.com/en-us/about-us/ventures" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Ventures</a><br /><br />
                <a href="https://www.emerson.com/en-us/about-us/emerson-and-stem" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">We <3 STEM</a>
            </div>
            <div class="col-lg-3" style="padding-top: 0.8%;">
              <p class="ourFont">Our Communities</p>
              <a href="" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Top Quartile</a><br /><br />
                <a href="https://www.emersontopquartile.com/#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Exchange365</a><br /><br />
                <a href="https://www.emersonexchange365.com/#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;">Automation Experts</a><br /><br />
                <a href="https://www.emersonautomationexperts.com/#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .875em; color: white;"></a><br /><br /><br />
                <a href="" style ="line-height: 1.3rem; font-family: 'Noto Sans', sans-serif; font-size: .775em; color: white; font-weight: 600; text-transform: uppercase;  ">Connect with Us</a><br/><br/>
                <a href="https://www.facebook.com/EmersonCorporate/#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~"><img class="socMed" src="https://www.emerson.com/resource/blob/footer-social-icon-facebook-data-9860368.png"></a>
                <a href="https://www.linkedin.com/company/emerson#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~"><img class="socMed" src="https://www.emerson.com/resource/blob/footer-social-icon-linkedin-data-9860378.png"></a>
                <a href="https://x.com/Emerson_News#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~"><img class="socMed" src="https://www.emerson.com/resource/blob/footer-social-icon-x-data-9860370.png"></a>
                <a href="https://videos.emerson.com/?_gl=1*am21bd*_gcl_au*MTcwNDIwNTk0Ny4xNzE5MzAzOTYw*_ga*MjAzMTI5MTA3LjE2NjIxMjgzMTE.*_ga_1MGRRDNV9H*MTcyMDc4MDE1OC41MDguMS4xNzIwNzgxMjI5LjAuMC4w#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~"><img class="socMed" src="https://www.emerson.com/resource/blob/footer-social-icon-youtube-data-9860372.png"></a>
              </div>
          </div>
        </nav>
		<div class="padded-container" style="height: 400px;">
			<div class="">
        <div class="row">
         
        </div>
      </div> </div><div class="bottom">
		<div class="padded-container">
      <div class="row" >
      <div class="col-xs-12 col-sm-12" style="text-align: left;">
      <div class="copyright">©2025 Emerson Electric Co. All rights reserved.</div>
      <ul class="allList" role="navigation" style="padding-left: 0;">
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/privacy-notice" >Privacy Notice</a><span class="spanList">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/cookie-notice" >Cookies</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/terms-of-use" >Terms of Use</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/data-protection" >Data Protection</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/imprint" >Imprint</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/accessibility" >Accessibility</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://go.emersonautomation.com/subscribe?utm_source=eas_gbl-ftr&utm_medium=mixe&utm_content=su-g009&utm_campaign=21geasb-subs44&subch=EMR_WEB#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" >Communication Preferences</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://go.emersonautomation.com/reportvulnerability_en?utm_source=emr-s&utm_medium=vtye&utm_content=emerson.com/reportvulnerability/English&utm_campaign=21gEMR-reportvulnerability/E02#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" >Report a Vulnerability</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://go.emersonautomation.com/CCPA#xd_co_f=ZTA3ZGE1YjUtNGMzYi00NGVmLWE5ZDQtYTAwMWVlZDE4YmM0~" >Do Not Sell or Share my Personal Information</a><span class="">|</span></li>
      <li class="list"><a class="forPad" href="https://www.emerson.com/en-us/transparency-in-coverage-machine-readable-files" >Transparency in Coverage Machine-Readable Files</a></li>
      </ul>
      </div> </div>
      </div>

		</div>
	  </div>
	 </div>
	</v-footer>
</template>

<script>
export default {
  name:"EmersonFooter",
  methods:{
	showDisclaimer(){
		this.$store.state.showDisclaimer = true
	}
  }
}

</script>

<style src='../assets/en-us.css' scoped></style>
<style scoped>
@font-face {
    font-family: 'Noto Sans';
    src: url('../fonts/Noto_Sans/NotoSans-Light.ttf') format("truetype");
}
.divider{
	padding-left: 10px;
	padding-right: 10px;
}
a{
	color: white;
	text-decoration: none;
}
.title{
	font-size: 15px;
	margin-right: 15px;
	color: gray;
}

.copyright{
	color:white;
	width: 1180px!important;
	text-align: left;
	display: flex;
}
.socmed-container{
	background-color: black!important;
	justify-content: center;
	height: 55px;
}
.socmed{
	justify-content: right;
	text-align: right;
	width: 50%;
}
.socmed-content{
	margin-right: 10px;	
}
.socmed-image{
	width: 28px;
	height: 28px;
}
.privacy-content{
	margin-right: 15px;
	color: white !important;
}
.privacy-container{
	font-size: 10px;
	width: 1180px;
	color: white !important;
	text-align: left;
}
a{
	color: #00AA7E;
}
.P005-promo-double-right img {
    max-width: 100%;
    height: auto;  
	}
    
    .image-container img {
    max-width: 100%;
    height: 100%;
    }
    .emersonLogoFooter{
      width: 154px;
      height: auto;
    }
    .ourFont{
      font-family: "Noto Sans", sans-serif;
      font-size: 12px;
      color: white;
      font-weight: 700;
      text-transform: uppercase;
    }
    .spanStyle{
      font-family: "Noto Sans", sans-serif;
      font-size: .875em;
      color: white;
    }
.socMed{
  height: 24px;
  max-height: 24px;
  margin-right: 6%;
  filter: brightness(80%);
}
.socMed:hover{
      filter: brightness(100%);
}
.list{
      font-family: "Noto Sans", sans-serif;
      font-size: .75rem;
    }
.spanList{
      padding-left: 0%;
}
.forPad{
      padding-right: 7px;
}
  
th{
    text-align: center;
}
	
</style>